import React from 'react';

import isEmpty from 'lodash-es/isEmpty';

import { FlexBox, FlexBoxColumn, FlexBoxSpaceBetween } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';
import { InnerButton } from '@ecp/common/src/components/button/Button';
import { TextButton } from '@ecp/common/src/components/button/TextButton';

import useSiteInfo from '@fo-hooks/common/useSiteInfo';
import { StyledTextBox, StyledAtag } from '@ecp/fo/sites/skypass/styles/footer/SkypassFooterBottomStyles';

export default function SkypassFooterBottom() {
  const {
    systemInformation: { customerCenterTel, customerCenterGuide, resdEmail },
    operationTime,
    lunchTime,
  } = useSiteInfo();

  const handleBusinessInfoClick = () => {
    window.open('https://www.ftc.go.kr/www/bizContents.do?key=253');
  };

  function onClickMailTo() {
    const emails = 'mailTo:' + resdEmail;
    window.location.href = emails;
  }

  return (
    <FlexBoxSpaceBetween width={'1330px'} align-items={'flex-start'} style={{ marginTop: '24px' }}>
      <FlexBoxColumn align-items={'flex-start'}>
        <FlexBox justify-content={'flex-start'} gap={'20px'}>
          <StyledTextBox>(주) 대한항공 대표이사 우기홍 외 1명</StyledTextBox>
          <StyledTextBox>서울특별시 강서구 하늘길 260</StyledTextBox>
          <StyledTextBox>문의전화 {customerCenterTel}</StyledTextBox>
          <StyledTextBox>
            이메일&nbsp;
            <TextButton
              textProps={{
                weight: '350',
                size: '13px',
              }}
              onClick={onClickMailTo}
            >
              {' '}
              {isEmpty(resdEmail) ? '' : resdEmail}
            </TextButton>
          </StyledTextBox>
        </FlexBox>
        <FlexBox justify-content={'flex-start'} gap={'20px'}>
          <StyledTextBox>호스팅 사업자 : 삼성SDS(주)</StyledTextBox>
          <StyledTextBox gap={'5px'}>
            사업자등록번호 110-81-14794
            <InnerButton
              width={'66px'}
              height={'20px'}
              style={{ padding: '0', borderRadius: '0' }}
              onClick={handleBusinessInfoClick}
            >
              <TextBox size={'12px'} weight={350}>
                <StyledAtag
                  href="https://www.ftc.go.kr/www/bizContents.do?key=253"
                  target="_blank"
                  title="새 창 열림"
                  rel="noreferrer"
                >
                  사업자 확인
                </StyledAtag>
              </TextBox>
            </InnerButton>
          </StyledTextBox>
          <StyledTextBox>통신판매업 신고번호(제 2006-16-3010호)</StyledTextBox>
        </FlexBox>
        <FlexBox justify-content={'flex-start'} gap={'20px'}>
          <StyledTextBox>개인정보보호책임자 : 최희정 상무</StyledTextBox>
        </FlexBox>
      </FlexBoxColumn>
      <FlexBoxColumn width={'310px'} align-items={'flex-start'}>
        <TextBox weight={'350'} height={'22px'}>
          고객센터
        </TextBox>
        <TextBox size={'28px'} weight={'500'} height={'45px'}>
          {customerCenterTel}
        </TextBox>
        <Spacing top={6} />
        <TextBox weight={'350'}>
          {operationTime} {lunchTime}
          <br />
          {customerCenterGuide}
        </TextBox>
      </FlexBoxColumn>
    </FlexBoxSpaceBetween>
  );
}
